module.exports = __webpack_public_path__ + "img/extended.083c1aa4.png";